module.exports = __webpack_public_path__ + "static/media/image-4.39d6f64d.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/Ecommerce/image-4.png
// module id = 443
// module chunks = 0